<template>
    <div class="content">
        <app-header></app-header>
        <main id="page-main">

            <div>
                <router-view @refresh="refresh()"></router-view>
                <header class="content-header">
                    <div class="wrapper">

                        <div>
                            <h1>Médias</h1>
                            <p>Gestion des médias</p>
                        </div>

                      <actions-dropdown>
                        <li v-if="$aclInterfaceValidator('weeboxcore.media.import')" @click="importFile()">
                          <icon name="upload-cloud-01"/>
                          <span>Importer des médias</span>
                        </li>
                      </actions-dropdown>

                    </div>
                </header>
                <div class="content-body">

                    <section style="padding: 1.25rem 2.5rem;">
                        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

                        <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

                        <div class="medias">
                            <div v-for="item in resources">
                                <figure v-bind:style="{ backgroundImage: 'url('+item.url+')' }">
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="/>
                                </figure>
                                <input type="text" :value="item.original_filename"/>
                            </div>
                        </div>
                    </section>

                    <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

                </div>
            </div>

        </main>
    </div>
</template>
<script>

    import MediaService from './MediaService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                uploads: []
            }
        },
        mounted: function(){
        },
        methods: {
            getResource: function(){
                return MediaService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/media/Index.vue